import { CapoPlugin } from "/home/runner/work/ss-bonsai-admin-frontend/ss-bonsai-admin-frontend/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];